/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { imageHistoryDataCategorySchema } from './ImageHistoryDataCategorySchema'
import { imageHistoryDataCollectionNameSchema } from './ImageHistoryDataCollectionNameSchema'

export const imageHistoryDataSchema = z.object({
	historyUpdatedAt: z.iso.datetime(),
	id: z.string(),
	name: z.string(),
	fileName: z.string(),
	category: imageHistoryDataCategorySchema,
	mimeType: z.string().nullable(),
	size: z.number(),
	humanReadableSize: z.string(),
	url: z.string(),
	collectionName: imageHistoryDataCollectionNameSchema,
	width: z.number(),
	height: z.number(),
	isPlaceholder: z.boolean(),
	isGenerating: z.boolean(),
	createdAt: z.iso.datetime(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type ImageHistoryDataSchema = z.infer<typeof imageHistoryDataSchema>
